<template>
  <div>
    <div class="main-content bg-white" v-if="$currentUser.role !== 'admin'">
      <span class="alert-danger">У вас нет доступа к этой странице.</span>
    </div>
    <div class="main-content bg-white" v-if="$currentUser.role === 'admin'">
      <div class="page-header">
        <h3 class="page-title">Группы пользователей</h3>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
          <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                 v-b-modal.createUserGroup>
            Создать группу
          </b-btn>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div v-if="userGroups.length > 0">
            <b-table hover responsive bordered
                     small
                     :items="userGroups"
                     :fields="fields"
                     no-local-sorting
                     :sort-by.sync="sortBy"
                     @sort-changed="getUserGroups"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" class="btn btn-warning"
                          @click.stop="editUserGroup(row)">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
                <b-button size="sm" class="btn btn-danger"
                          @click.stop="deleteUserGroup(row.item)">
                  <i class="icon-fa icon-fa-trash-o"></i>
                </b-button>
              </template>
              <template v-slot:cell(users)="row">
                                <span v-for="(item, index) in row.item.users">
                                    <span v-if="index == row.item.users.length - 1">{{ item.name }}</span>
                                    <span
                                        v-if="index >= 0 && index < row.item.users.length - 1">{{
                                        item.name
                                      }}, </span>
                                </span>
                <div v-if="row.item.users == 0"></div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <b-modal id="createUserGroup" ref="userGroupCreateModal" size="md" title="Создать группу"
               @hidden="hideCreateModal"
               hide-footer>
        <CreateUserGroupModal></CreateUserGroupModal>
      </b-modal>

      <b-modal ref="userGroupEditModal" @hidden="hideCreateModal" id="userGroupEditModal" size="md"
               title="Редактировать группу" hide-footer>
        <EditUserGroupModal v-bind:userGroup="selectedUserGroup"></EditUserGroupModal>
      </b-modal>
    </div>
  </div>
</template>

<script>
import UsersService from '../../services/usersDataService'
import CreateUserGroupModal from "./modals/CreateUserGroupModal.vue";
import EditUserGroupModal from "./modals/EditUserGroupModal.vue";

export default {
  name: 'userGroups',
  components: {
    EditUserGroupModal,
    CreateUserGroupModal,
    UsersService: UsersService
  },
  data() {
    return {
      selectedUserGroup: null,
      userGroups: [],
      fields: [
        {
          key: 'title',
          label: 'Название',
          sortable: true
        },
        {
          key: 'users',
          label: 'Пользователи',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Действия',
          tdAttr: {'align': "center"}
        }
      ],
      sortBy: 'created_at',
      sortDesc: true,
      sortDirection: 'desc',
    }
  },
  methods: {
    getUserGroups(sort) {
      if (!sort) {
        sort = this;
      }

      UsersService.getUserGroups(sort)
          .then(userGroups => {
            this.userGroups = userGroups;
          })
    },
    editUserGroup(item) {
      this.selectedUserGroup = item
      this.$refs.userGroupEditModal.show()
    },
    deleteUserGroup(userGroup) {
      this.$bvModal.msgBoxConfirm('ID: ' + userGroup.id + ' Название: ' + userGroup.title, {
        title: 'Вы точно уверены, что хотите удалить?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'ДА',
        cancelTitle: 'НЕТ',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if (value !== true) {
              return
            }

            if (!confirm('Точно удаляем?')) {
              return;
            }
            UsersService.deleteUserGroup(userGroup.id)
                .then(response => {
                  if (response.success) {
                    this.getUserGroups();

                    toastr.success('Группа удалена!')
                  }
                })
          })
          .catch(err => {
          })
    },
    hideCreateModal() {
      this.getUserGroups();

      this.$refs.userGroupCreateModal.hide()
      this.$refs.userGroupEditModal.hide()
    },
  },
  beforeMount() {
    this.getUserGroups();
  },
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/UserGroups.vue